const getters = {
    payments: (state) => state.payments,
    loading: state => state.loading
};

export default getters;